<div class="tool-modal">
    <div class="tool-modal__header">
        <h3>{{ title }}</h3>
        <button type="button" class="tool-modal__close" (click)="activeModal.dismiss()" aria-label="Close">&times;</button>
    </div>

    <form class="tool-modal__body" (ngSubmit)="submit()">
        <div class="customer-line">
            <span>Customer</span>
            <strong>{{ gateway.customerName || gateway.descr || '—' }}</strong>
        </div>

        @if (mode === 'username') {
            <!-- What is being replaced. Without it the admin is renaming an
                 account whose current login is nowhere on the page: the table
                 shows the customer name, never the username. -->
            <div class="customer-line">
                <span>Current username</span>
                <strong>{{ gateway.username || 'Unknown' }}</strong>
            </div>
            <!-- The username is the cloud login, so this renames the account, not
                 this gateway. Say so when the account owns others — the clicked
                 row's customer name is often not the same as the siblings'. -->
            @if (siblingGateways.length) {
                <p class="scope-warning">
                    This changes the login for the whole account, which also owns
                    {{ siblingGateways.length }}
                    {{ siblingGateways.length === 1 ? 'other gateway' : 'other gateways' }}:
                    <strong>{{ siblingLabels }}</strong>
                </p>
            }
            <label class="field">
                <span>New username (email)</span>
                <input ngbAutofocus type="email" name="newUsername" [(ngModel)]="newUsername" autocomplete="off" required />
            </label>
        } @else if (mode === 'password') {
            <label class="field">
                <span>New password</span>
                <input ngbAutofocus type="password" name="newPassword" [(ngModel)]="newPassword" autocomplete="new-password" required />
            </label>
            <label class="field">
                <span>Confirm new password</span>
                <input type="password" name="confirmPassword" [(ngModel)]="confirmPassword" autocomplete="new-password" required />
            </label>
        } @else {
            <div class="field">
                <span>Old UID</span>
                <input type="text" [value]="gateway.uid" disabled />
            </div>
            <div class="field">
                <span>Replace with</span>
                <ng-select
                    class="tool-select"
                    name="replacementUid"
                    [items]="candidateOptions"
                    bindLabel="label"
                    bindValue="uid"
                    placeholder="Select a gateway…"
                    [clearable]="false"
                    [(ngModel)]="replacementUid">
                </ng-select>
            </div>
        }

        @if (error) {
            <p class="error">{{ error }}</p>
        }

        <button type="submit" class="tool-modal__submit" [disabled]="submitting">Save</button>
    </form>
</div>
